export default "__VITE_ASSET__5dtXk2oM__"